// extracted by mini-css-extract-plugin
export default {"JobSpecs":"styles_JobSpecs__YCyTz"};